import React, { Suspense, useEffect, useState } from 'react';
import './App.css';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from "react-router-dom";
import SumOtherPayment from "./components/Content/Informer/SumOtherPayment/SumOtherPayment";
import { ScrollToTop } from "./components/ScrollToTop/ScrollToTop";
import FooterSec from "./components/Footer/FooterSec";
import { LanguageProvider } from './components/Language/LanguageContext';
import { NavbarProvider } from './components/Navbar/NavbarContext';
import { DataProvider } from './components/Contexts/DataProvider';

const Loader = React.lazy(() => import("./components/Loader/Loader"));
const Head = React.lazy(() => import("./components/Content/Head/Head"));
const Navbar = React.lazy(() => import("./components/Navbar/Navbar"));
const Footer = React.lazy(() => import("./components/Footer/Footer"));
const Minister = React.lazy(() => import("./components/Content/Minister/Minister"));
const MinisterStaffBiographies = React.lazy(() => import("./components/Content/MinisterStaffBiographies/MinisterStaffBiographies"));
const HistoricalOverviews = React.lazy(() => import("./components/Content/Ministry/HistoricalOverviews/HistoricalOverviews"));
const OurMinisters = React.lazy(() => import("./components/Content/Ministry/OurMinisters/OurMinisters"));
const OureMinister = React.lazy(() => import("./components/Content/Ministry/OurMinisters/OureMinister"));
const Statute = React.lazy(() => import("./components/Content/Ministry/Statute/Statute"));
const Checklist = React.lazy(() => import("./components/Content/Ministry/Checklist/Checklist"));
const ChecklistWithParent = React.lazy(() => import("./components/Content/Ministry/Checklist/ChecklistWithParent"));

const AttachedMinisters = React.lazy(() => import("./components/Content/Ministry/AttachedMinisters/AttachedMinisters"));
const Message = React.lazy(() => import("./components/Content/Minister/Message/Message"));
const DayReports = React.lazy(() => import("./components/Content/Minister/DayReports/DayReports"));
const NewsPage = React.lazy(() => import("./components/Content/InformationPlatform/NewsPage/NewsPage"));
const NewsItem = React.lazy(() => import("./components/Content/InformationPlatform/NewsPage/NewsItem"));
const VideoItem = React.lazy(() => import("./components/Content/InformationPlatform/Videos/VideoItem"));
const VacanciesPage = React.lazy(() => import("./components/Content/InformationPlatform/VacansiesPage/VacanciesPage"));
const StaffOfTheMinister = React.lazy(() => import("./components/Content/Staff/StaffOfTheMinister/StaffOfTheMinister"));
const StaffOfTheMinistry = React.lazy(() => import("./components/Content/Staff/StaffOfTheMinistry/StaffOfTheMinistry"));
const BodySubordinateToTheministry = React.lazy(() => import("./components/Content/Staff/BodySubordinateToTheministry/BodySubordinateToTheministry"));
const InfrastructureOfTheMinistry = React.lazy(() => import("./components/Content/Staff/InfrastructureOfTheMinistry/InfrastructureOfTheMinistry"));
const StateNonProfitOrganizations = React.lazy(() => import("./components/Content/Staff/StateNonProfitOrganizations/StateNonProfitOrganizations"));
const Budget = React.lazy(() => import("./components/Content/Ministry/Budget/Budget"));
const BudgetItem = React.lazy(() => import("./components/Content/Ministry/Budget/BudgetItem"));
const BudgetSubItem = React.lazy(() => import("./components/Content/Ministry/Budget/BudgetSubItem"));
const Procedure = React.lazy(() => import("./components/Content/Informer/Procedure/Procedure"));
const InformationOfficer = React.lazy(() => import("./components/Content/Informer/InformationOfficer/InformationOfficer"));
const Certifications = React.lazy(() => import("./components/Content/Informer/Certifications/Certifications"));
const Report = React.lazy(() => import("./components/Content/Ministry/Report/Report"));
const ReportWithParent = React.lazy(() => import("./components/Content/Ministry/Report/ReportWithParent"));
const Procurement = React.lazy(() => import("./components/Content/Ministry/Procurement/Procurement"));
const ProcurementWithParent = React.lazy(() => import("./components/Content/Ministry/Procurement/ProcurementWithParent"));
const Employment = React.lazy(() => import("./components/Content/QuestionandAnswer/Employment/Employment"));
const EmploymentItem = React.lazy(() => import("./components/Content/QuestionandAnswer/Employment/EmploymentItem"));
const EnsuringEqualOpportunity = React.lazy(() => import("./components/Content/QuestionandAnswer/EnsuringEqualOpportunity/EnsuringEqualOpportunity"));
const EnsuringEqualOpportunityItem = React.lazy(() => import("./components/Content/QuestionandAnswer/EnsuringEqualOpportunity/EnsuringEqualOpportunityItem"));
const IssuesElderly = React.lazy(() => import("./components/Content/QuestionandAnswer/IssuesElderly/IssuesElderly"));
const MedicalSocialExpertises = React.lazy(() => import("./components/Content/QuestionandAnswer/MedicalSocialExpertises/MedicalSocialExpertises"));
const Question = React.lazy(() => import("./components/Content/QuestionandAnswer/Question/Question"));
const SocialSupport = React.lazy(() => import("./components/Content/QuestionandAnswer/SocialSupport/SocialSupport"));
const PensionSecurity = React.lazy(() => import("./components/Content/QuestionandAnswer/PensionSecurity/PensionSecurity"));
const PensionItem = React.lazy(() => import("./components/Content/QuestionandAnswer/PensionSecurity/PensionItem"));
const IssuesOfPersonsWithDisability = React.lazy(() => import("./components/Content/QuestionandAnswer/IssuesOfPersonsWithDisability/IssuesOfPersonsWithDisability"));
const SocialCooperations = React.lazy(() => import("./components/Content/Informer/SocialCooperations/SocialCooperations"));
const SocialCooperationItem = React.lazy(() => import("./components/Content/Informer/SocialCooperations/SocialCooperationItem"));
const Videos = React.lazy(() => import("./components/Content/InformationPlatform/Videos/Videos"));
const NationalCommissions = React.lazy(() => import("./components/Content/Informer/NationalCommissions/NationalCommissions"));
const NationalCommissionItems = React.lazy(() => import("./components/Content/Informer/NationalCommissions/NationalCommissionItems"));
const Announcements = React.lazy(() => import("./components/Content/Informer/Announcements/Announcements"));
const AnnouncementItem = React.lazy(() => import("./components/Content/Informer/Announcements/AnnouncementItem"));
const Auctions = React.lazy(() => import("./components/Content/Informer/Auctions/Auctions"));
const AuctionItem = React.lazy(() => import("./components/Content/Informer/Auctions/AuctionItem"));
const Services = React.lazy(() => import("./components/Content/Informer/Services/Services"));
const ServicesWithParent = React.lazy(() => import("./components/Content/Informer/Services/ServicesWithParent"));
const ServiceItem = React.lazy(() => import("./components/Content/Informer/Services/ServiceItem"));
const PublicDiscussions = React.lazy(() => import("./components/Content/Informer/PublicDiscussions/PublicDiscussions"));
const Competitions = React.lazy(() => import("./components/Content/Informer/Competitions/Competitions"));
const CompetitionItem = React.lazy(() => import("./components/Content/Informer/Competitions/CompetitionItem"));
const EducationalCourses = React.lazy(() => import("./components/Content/Informer/EducationalCourses/EducationalCourses"));
const EducationalCoursesWithParent = React.lazy(() => import("./components/Content/Informer/EducationalCourses/EducationalCoursesWithParent"));
const ProfessionalOrientation = React.lazy(() => import("./components/Content/QuestionandAnswer/ProfessionalOrientation/ProfessionalOrientation"));
const BlockItem = React.lazy(() => import("./components/Content/Head/BlockItem/BlockItem"));
const BlockPage = React.lazy(() => import("./components/Content/Head/BlockPage/BlockPage"));
const Secretary = React.lazy(() => import("./components/Content/Secretary/Secretary"));
const ExternalConnection = React.lazy(() => import("./components/Content/ExternalConnection/ExternalConnection"));
const ExternalConnectionBlog = React.lazy(() => import("./components/Content/ExternalConnection/ExternalConnectionBlog"));
const SecretaryBlog = React.lazy(() => import("./components/Content/Secretary/SecretaryBlog"));
const MemorandumsPage = React.lazy(() => import("./components/Content/InformationPlatform/MemorandumsPage/MemorandumsPage"));
const MemorandumsItem = React.lazy(() => import("./components/Content/InformationPlatform/MemorandumsPage/MemorandumsItem"));
const Feedback = React.lazy(() => import("./components/Content/InformationPlatform/Feedback/Feedback"));
const CompetitionResultsItems = React.lazy(() => import("./components/Content/Informer/CompetitionResults/CompetitionResultItems"));
const CompetitionResultPage = React.lazy(() => import("./components/Content/Informer/CompetitionResults/CompetitionResultsPage"));
const MinistryVacancies = React.lazy(() => import("./components/Content/Informer/MinistryVacancies/MinistryVacancies"));
const MinistryVacanciesItems = React.lazy(() => import("./components/Content/Informer/MinistryVacancies/MinistryVacanciesItems"));
const FreedomInformationOfficer = React.lazy(() => import("./components/Content/InformationCenter/InformationOfficer/FreedomInformationOfficer"));
const CorruptionPrograms = React.lazy(() => import("./components/Content/InformationCenter/CorruptionPrograms/CorruptionPrograms"));
const NotificationOfficer = React.lazy(() => import("./components/Content/InformationCenter/NotificationOfficer/NotificationOfficer"));
const InformationRequests = React.lazy(() => import("./components/Content/InformationCenter/InformationRequests/InformationRequests"));
const ApplicationTheory = React.lazy(() => import("./components/Content/InformationCenter/ApplicationTheory/ApplicationTheory"));
const Banks = React.lazy(() => import("./components/Content/Banners/Banks/Banks"));
const ImprovingPrograms = React.lazy(() => import("./components/Content/Banners/ImprovingPrograms/ImprovingPrograms"));
const AvailabilityStatements = React.lazy(() => import("./components/Content/Banners/AvailabilityStatements/AvailabilityStatements"));
const ProcessingPersonalDatas = React.lazy(() => import("./components/Content/Banners/ProcessingPersonalDatas/ProcessingPersonalDatas"));
const ProstheticOrthopedics = React.lazy(() => import("./components/Content/Banners/ProstheticOrthopedics/ProstheticOrthopedics"));
const ForeignCountriesBusinessTrip = React.lazy(() => import("./components/Content/Banners/ForeignCountriesBusinessTrip/ForeignCountriesBusinessTrip"));
const ExpertReports = React.lazy(() => import("./components/Content/PersonnelManagement/ExpertReports/ExpertReports"));
const ExpertReportsItem = React.lazy(() => import("./components/Content/PersonnelManagement/ExpertReports/ExpertReportsItem"));
const StatisticsApplications = React.lazy(() => import("./components/Content/InformationCenter/StatisticsApplications/StatisticsApplications"));
const StatisticsApplicationsItem = React.lazy(() => import("./components/Content/InformationCenter/StatisticsApplications/StatisticsApplicationsItem"));
const Redistributions = React.lazy(() => import("./components/Content/InformationCenter/Redistributions/Redistributions"));
const RedistributionsItem = React.lazy(() => import("./components/Content/InformationCenter/Redistributions/RedistributionsItem"));
const BusinessTripReports = React.lazy(() => import("./components/Content/InformationCenter/BusinessTripReports/BusinessTripReports"));
const BusinessTripReportsItem = React.lazy(() => import("./components/Content/InformationCenter/BusinessTripReports/BusinessTripReportsItem"));
const AnnualPrograms = React.lazy(() => import("./components/Content/InformationCenter/AnnualPrograms/AnnualPrograms"));
const AnnualProgramsItem = React.lazy(() => import("./components/Content/InformationCenter/AnnualPrograms/AnnualProgramsItem"));
const AdoptedLegalActs = React.lazy(() => import("./components/Content/InformationCenter/AdoptedLegalActs/AdoptedLegalActs"));
const AdoptedLegalActsItem = React.lazy(() => import("./components/Content/InformationCenter/AdoptedLegalActs/AdoptedLegalActsItem"));
const GenderEquality = React.lazy(() => import("./components/Content/InformationCenter/GenderEquality/GenderEquality"));
const GenderEqualityItem = React.lazy(() => import("./components/Content/InformationCenter/GenderEquality/GenderEqualityItem"));
const NpoSummaries = React.lazy(() => import("./components/Content/Staff/NpoSummaries/NpoSummaries"));
const NpoSummariesWithParent = React.lazy(() => import("./components/Content/Staff/NpoSummaries/NpoSummariesWithParent"));
const HeadBanner = React.lazy(() => import("./components/Content/Head/HeadBanner/HeadBanner"));
const SearchResults = React.lazy(() => import("./components/SearchContent/SearchResults"));
const SearchComponent = React.lazy(() => import("./components/SearchContent/SearchComponent"));


export default function App() {
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        const loggedIn = !!localStorage.getItem('owt-token');
        setIsLogin(loggedIn);
    }, []);



    return (
        <LanguageProvider>
            <NavbarProvider>
                <DataProvider>
                    <Router>
                        <div className="App">
                            <ScrollToTop />
                            <Navbar />
                            <Suspense fallback={<div>Loading...</div>}>
                                <Routes>

                                    <Route path="/"
                                        element={<Head isLogin={isLogin} />} />

                                    <Route exact path="/news"
                                        element={<NewsPage
                                            isLogin={isLogin} />} />

                                    <Route exact path="/minister"
                                        element={<Minister
                                            isLogin={isLogin} />} />

                                    <Route exact path="/message"
                                        element={<Message
                                            isLogin={isLogin} />} />

                                    <Route exact path="/100-day-report"
                                        element={<DayReports
                                            isLogin={isLogin} />} />

                                    <Route exact path="/historical-overviews"
                                        element={<HistoricalOverviews
                                            isLogin={isLogin} />} />

                                    <Route exact path="/our-ministers"
                                        element={<OurMinisters
                                            isLogin={isLogin} />} />


                                    <Route exact path="/our-minister/:id"
                                        element={<OureMinister
                                            isLogin={isLogin} />} />

                                    <Route exact path="/statute"
                                        element={<Statute
                                            isLogin={isLogin} />} />

                                    <Route exact path="/checklist"
                                        element={<Checklist
                                            isLogin={isLogin} />} />

                                    <Route exact path="/checklist/:id"
                                        element={<ChecklistWithParent
                                            isLogin={isLogin} />} />

                                    <Route exact path="/public-council-attached-to-the-minister"
                                        element={<AttachedMinisters
                                            isLogin={isLogin} />} />

                                    <Route exact path="/budget"
                                        element={<Budget isLogin={isLogin} />} />

                                    <Route exact path="/budget-item/:id"
                                        element={<BudgetItem
                                            isLogin={isLogin} />} />


                                    <Route exact path="/budget-sub-item/:id"
                                        element={<BudgetSubItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/report"
                                        element={<Report isLogin={isLogin} />} />

                                    <Route exact path="/reports/:id"
                                        element={<ReportWithParent
                                            isLogin={isLogin} />} />


                                    <Route exact path="/procurement"
                                        element={<Procurement
                                            isLogin={isLogin} />} />

                                    <Route exact path="/educational_courses"
                                        element={<EducationalCourses
                                            isLogin={isLogin} />} />

                                    <Route exact path="/educational_courses/parent/:id"
                                        element={<EducationalCoursesWithParent
                                            isLogin={isLogin} />} />


                                    <Route exact path="/procurement/:id"
                                        element={<ProcurementWithParent
                                            isLogin={isLogin} />} />

                                    <Route exact path="/secretary"
                                        element={<Secretary
                                            isLogin={isLogin} />} />

                                    <Route exact path="/external-connection"
                                        element={<ExternalConnection
                                            isLogin={isLogin} />} />

                                    <Route exact path="/sum-other-payments"
                                        element={<SumOtherPayment
                                            isLogin={isLogin} />} />

                                    <Route exact path="/news/:id"
                                        element={<NewsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/vacancies"
                                        element={<VacanciesPage
                                            isLogin={isLogin} />} />

                                    <Route path="/staff-of-the-minister"
                                        element={<StaffOfTheMinister
                                            isLogin={isLogin} />} />

                                    <Route path="/staff-of-the-ministry"
                                        element={<StaffOfTheMinistry
                                            isLogin={isLogin} />} />

                                    <Route path="/body-subordinate-to-the-ministry" element={<BodySubordinateToTheministry isLogin={isLogin} />} />

                                    <Route path="/state-non-profit-organizations" element={<StateNonProfitOrganizations isLogin={isLogin} />} />

                                    <Route path="/infrastructure-of-the-ministry" element={<InfrastructureOfTheMinistry isLogin={isLogin} />} />

                                    <Route exact path="/procedure-for-receiving-information" element={<Procedure isLogin={isLogin} />} />

                                    <Route exact path="/employment"
                                        element={<Employment
                                            isLogin={isLogin} />} />

                                    <Route exact path="/employment-item/:id"
                                        element={<EmploymentItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/ensuring-equal-opportunity"
                                        element={<EnsuringEqualOpportunity
                                            isLogin={isLogin} />} />

                                    <Route exact path="/ensuring-equal-opportunity-item/:id"
                                        element={<EnsuringEqualOpportunityItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/issues_elderly"
                                        element={<IssuesElderly
                                            isLogin={isLogin} />} />

                                    <Route exact path="/medical-social-expertises"
                                        element={<MedicalSocialExpertises
                                            isLogin={isLogin} />} />

                                    <Route exact path="/question"
                                        element={<Question
                                            isLogin={isLogin} />} />

                                    <Route exact path="/social_support"
                                        element={<SocialSupport
                                            isLogin={isLogin} />} />

                                    <Route exact path="/pension-security"
                                        element={<PensionSecurity
                                            isLogin={isLogin} />} />

                                    <Route exact path="/pension-item/:id"
                                        element={<PensionItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/issues-of-persons-with-disabilities"
                                        element={<IssuesOfPersonsWithDisability
                                            isLogin={isLogin} />} />

                                    <Route exact path="/freedom-of-Information-officer"
                                        element={<InformationOfficer
                                            isLogin={isLogin} />} />

                                    <Route exact path="/certifications"
                                        element={<Certifications
                                            isLogin={isLogin} />} />

                                    <Route exact path="/professional-orientation"
                                        element={<ProfessionalOrientation
                                            isLogin={isLogin} />} />

                                    <Route exact path="/social-cooperations"
                                        element={<SocialCooperations
                                            isLogin={isLogin} />} />

                                    <Route exact path="/social-cooperation/:id"
                                        element={<SocialCooperationItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/videos"
                                        element={<Videos isLogin={isLogin} />} />

                                    <Route exact path="/video/:id"
                                        element={<VideoItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/national-commissions"
                                        element={<NationalCommissions
                                            isLogin={isLogin} />} />

                                    <Route exact path="/national-commission/:id"
                                        element={<NationalCommissionItems
                                            isLogin={isLogin} />} />

                                    <Route exact path="/announcements"
                                        element={<Announcements
                                            isLogin={isLogin} />} />

                                    <Route exact path="/announcement/:id"
                                        element={<AnnouncementItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/auctions"
                                        element={<Auctions
                                            isLogin={isLogin} />} />

                                    <Route exact path="/auction/:id"
                                        element={<AuctionItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/services"
                                        element={<Services
                                            isLogin={isLogin} />} />

                                    <Route exact path="/services/:id"
                                        element={<ServicesWithParent
                                            isLogin={isLogin} />} />

                                    <Route exact path="/service/:id"
                                        element={<ServiceItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/public-discussions"
                                        element={<PublicDiscussions
                                            isLogin={isLogin} />} />

                                    <Route exact path="/competitions"
                                        element={<Competitions
                                            isLogin={isLogin} />} />

                                    <Route exact path="/competition/:id"
                                        element={<CompetitionItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/external-connection/blog/:id"
                                        element={<ExternalConnectionBlog
                                            isLogin={isLogin} />} />

                                    <Route exact path="/secretary/blog/:id"
                                        element={<SecretaryBlog
                                            isLogin={isLogin} />} />

                                    <Route exact path="/memorandums/:id"
                                        element={<MemorandumsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/memorandums"
                                        element={<MemorandumsPage
                                            isLogin={isLogin} />} />

                                    <Route exact path="/feedback"
                                        element={<Feedback
                                            isLogin={isLogin} />} />

                                    <Route exact path="/Programs-And-Services/:id"
                                        element={<BlockItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/Programs-And-Services/:page/:Id/:lang"
                                        element={<BlockPage
                                            isLogin={isLogin} />} />

                                    <Route exact path="/competition-results/:id"
                                        element={<CompetitionResultsItems
                                            isLogin={isLogin} />} />

                                    <Route exact path="/competition-results"
                                        element={<CompetitionResultPage
                                            isLogin={isLogin} />} />

                                    {/* TEMPORARILY DISABLED - ministry-vacancies routes */}
                                    {/*<Route exact path="/ministry-vacancies"
                                        element={<MinistryVacancies
                                            isLogin={isLogin} />} />

                                    <Route exact path="/ministry-vacancy/:id"
                                        element={<MinistryVacanciesItems
                                            isLogin={isLogin} />} />*/}

                                    <Route exact path="/freedom-information-officers"
                                        element={<FreedomInformationOfficer
                                            isLogin={isLogin} />} />

                                    <Route exact path="/anti-corruption-program-officers"
                                        element={<CorruptionPrograms
                                            isLogin={isLogin} />} />

                                    <Route exact path="/notification-officers"
                                        element={<NotificationOfficer
                                            isLogin={isLogin} />} />

                                    <Route exact path="/statistic-information-requestes"
                                        element={<InformationRequests
                                            isLogin={isLogin} />} />

                                    <Route exact path="/application-theories"
                                        element={<ApplicationTheory
                                            isLogin={isLogin} />} />

                                    <Route exact path="/banks"
                                        element={<Banks
                                            isLogin={isLogin} />} />

                                    <Route exact path="/improving-demographic-situation-programs"
                                        element={<ImprovingPrograms
                                            isLogin={isLogin} />} />

                                    <Route exact path="/availability-statements"
                                        element={<AvailabilityStatements
                                            isLogin={isLogin} />} />

                                    <Route exact path="/processing-personal-datas"
                                        element={<ProcessingPersonalDatas
                                            isLogin={isLogin} />} />

                                    <Route exact path="/prosthetic-orthopedics"
                                        element={<ProstheticOrthopedics
                                            isLogin={isLogin} />} />

                                    <Route exact path="/foreign-countries-business-trip"
                                        element={<ForeignCountriesBusinessTrip
                                            isLogin={isLogin} />} />

                                    <Route exact path="/expert-reports"
                                        element={<ExpertReports
                                            isLogin={isLogin} />} />

                                    <Route exact path="/expert-report-sub-items/:id"
                                        element={<ExpertReportsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/statistics-inquiries-applications"
                                        element={<StatisticsApplications
                                            isLogin={isLogin} />} />

                                    <Route exact path="/statistics-inquiries-applications-sub-items/:id"
                                        element={<StatisticsApplicationsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/redistributions"
                                        element={<Redistributions
                                            isLogin={isLogin} />} />

                                    <Route exact path="/redistributions-sub-items/:id"
                                        element={<RedistributionsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/business-trip-reports"
                                        element={<BusinessTripReports
                                            isLogin={isLogin} />} />

                                    <Route exact path="/business-trip-reports-sub-items/:id"
                                        element={<BusinessTripReportsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/annual-programs"
                                        element={<AnnualPrograms
                                            isLogin={isLogin} />} />

                                    <Route exact path="/annual-programs-sub-items/:id"
                                        element={<AnnualProgramsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/adopted-legal-acts"
                                        element={<AdoptedLegalActs
                                            isLogin={isLogin} />} />

                                    <Route exact path="/adopted-legal-acts-sub-items/:id"
                                        element={<AdoptedLegalActsItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/gender-equality"
                                        element={<GenderEquality
                                            isLogin={isLogin} />} />

                                    <Route exact path="/gender-equality-sub-items/:id"
                                        element={<GenderEqualityItem
                                            isLogin={isLogin} />} />

                                    <Route exact path="/minister-staff-biographies/:type/:id"
                                        element={<MinisterStaffBiographies
                                            isLogin={isLogin} />} />

                                    <Route exact path="/npo-summaries"
                                        element={<NpoSummaries
                                            isLogin={isLogin} />} />

                                    <Route exact path="/npo-summaries/:id"
                                        element={<NpoSummariesWithParent
                                            isLogin={isLogin} />} />

                                    <Route exact path="/head-banners/:lang"
                                        element={<HeadBanner
                                            isLogin={isLogin} />} />

                                    <Route exact path="/search-results"
                                        element={<SearchResults
                                            isLogin={isLogin} />} />

                                    <Route exact path="/search"
                                        element={<SearchComponent
                                            isLogin={isLogin} />} />


                                    <Route path="*" element={<Navigate to="/" replace />} />

                                </Routes>
                            </Suspense>
                            <Footer />
                            <FooterSec />
                        </div>
                    </Router>
                </DataProvider>
            </NavbarProvider>
        </LanguageProvider>
    );
}
